import {
    Directive,
    ElementRef,
    HostBinding,
    Input,
    OnDestroy,
    OnInit,
    Optional,
    Renderer2,
    Self
} from '@angular/core';
import { BaseDirective } from './base.directive';
import { NgControl } from '@angular/forms';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Subscription } from 'rxjs';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: 'input[euiInput]'
})
export class InputDirective extends BaseDirective implements OnInit, OnDestroy {

    @HostBinding('attr.disabled')
    @Input()
    public get disabled() {
        return this._disabled ? true : null;
    }
    public set disabled(state: any) {
        this._disabled = coerceBooleanProperty(state);
        // set BaseDirective Attribute
        super.euiDisabled = this._disabled;
    }

    @HostBinding('attr.readonly')
    @Input()
    public get readonly() {
        return this._elementRef.nativeElement.attributes.readonly || null;
    }
    public set readonly(state: any) {
        this._readonly = coerceBooleanProperty(state);
        if (this._readonly) {
            this._renderer.setAttribute(this._elementRef.nativeElement, 'readonly', 'true');
        } else {
            this._renderer.removeAttribute(this._elementRef.nativeElement, 'readonly');
        }
    }

    @HostBinding('attr.placeholder')
    @Input()
    public get placeholder(): string|null {
        return this.getPlaceholderAttribute();
    }
    public set placeholder(value: string|null) {
        this.setPlaceholderAttribute(value);
    }

    @HostBinding('attr.id')
    @Input()
    public get id(): string {
        return this._id;
    }
    public set id(value: string|null) {
        this.setIdAttribute(value);
    }

    protected _disabled: boolean;
    protected _readonly: boolean;
    protected _placeholder: string;
    protected _statusListener: Subscription;
    protected _id: string;

    constructor(protected _elementRef: ElementRef,
                protected _renderer: Renderer2,
                @Optional() @Self() protected control: NgControl) {
        super();
    }

    ngOnInit() {
        if (this.control) {
            // subscribe to NG control status changes to adjust inputs
            this._statusListener = this.control.statusChanges.subscribe(status => {
                this.euiDanger = status === 'INVALID' && this.control.touched;
                // TODO: implement classes for the Pending state (maybe a spinner and disabled?)
            });
        }
    }

    ngOnDestroy(): void {
        if (this._statusListener) {
            this._statusListener.unsubscribe();
        }
    }

    protected getPlaceholderAttribute(): string|undefined {
        // in readonly memorize placeholder value and remove placeholder. The reason is that CSS style for readonly
        // cannot hide the placeholder text
        if (this._elementRef.nativeElement.attributes['readonly']) {
            if (!this._placeholder) {
                this.setPlaceholderAttribute(this._elementRef.nativeElement.placeholder);
            }
            this._elementRef.nativeElement.placeholder = '';
            return undefined;
        }

        // keep placeholder's value
        this._placeholder = this._elementRef.nativeElement.placeholder || this._placeholder;
        return this._placeholder;
    }

    protected setPlaceholderAttribute(value: string|null) {
        this._renderer.setAttribute(this._elementRef.nativeElement, 'placeholder', value);
        this._placeholder = value;
    }

    protected setIdAttribute(value: string|null = null) {
        this._id = value ? value : `${this._elementRef.nativeElement.type}_${Math.floor(Math.random() * 1000000)}`;
    }
}
